import { createAction, props } from '@ngrx/store';
import { RunSegment, ScheduledRun } from '../models/schedule.model';

// Load Scheduled Runs
export const loadScheduledRuns = createAction('[ScheduledRun] Load Scheduled Run', props<{ organizationId: string, clientId: string, weeklyScheduleId: string  }>());
export const loadScheduledRunsSuccess = createAction('[ScheduledRun] Load Scheduled Run Success', props<{ scheduledRuns: ScheduledRun[] }>());

// Update Scheduled Run
export const updateScheduledRun = createAction('[ScheduledRun] Update Scheduled Run', props<{organizationId: string, scheduledRun: ScheduledRun }>());
export const updateScheduledRunSuccess = createAction('[ScheduledRun] Update Scheduled Run Success', props<{ scheduledRun: ScheduledRun }>());

// Create Schedule Run
export const createScheduledRun = createAction('[ScheduledRun] Create Scheduled Run', props<{organizationId: string, scheduledRun: ScheduledRun }>());
export const createScheduledRunSuccess = createAction('[ScheduledRun] Create Scheduled Run Success', props<{ scheduledRun: ScheduledRun }>());

// delete Schedule run
export const deleteScheduledRun = createAction('[ScheduledRun] Delete Scheduled Run', props<{organizationId: string, weeklyScheduleId: number, scheduledRunId: number }>());
export const deleteScheduledRunSuccess = createAction('[ScheduledRun] Delete Scheduled Run Success', props<{ scheduledRunId: number }>());

